export const GET_PENDING_RECEIVED_VOUCHER_ERROR =
  'GET_PENDING_RECEIVED_VOUCHER_ERROR';
export const GET_PENDING_RECEIVED_VOUCHER_START =
  'GET_PENDING_RECEIVED_VOUCHER_START';
export const GET_PENDING_RECEIVED_VOUCHER_SUCCESS =
  'GET_PENDING_RECEIVED_VOUCHER_SUCCESS';
